import { useEffect } from 'react'

const AdditionalInfoQuestion = ({ formData, setFormData }) => {
    return (
        <div className="mt-6 border border-gray-200 rounded-lg">
            <div className="flex items-center justify-between p-4 bg-blue-50 rounded-t-lg">
                <h2 className="text-lg font-semibold text-gray-800">
                    Step 8: Supporting Documents & Additional Information
                </h2>
            </div>
            <div className="p-4">
                <label htmlFor="additionalInfo" className="block text-sm font-medium text-gray-700 mb-2">
                    Please provide any supplementary information for the referral to help the clinical team with their assessment.
                </label>
                <textarea
                    id="additionalInfo"
                    name="additionalInfo"
                    rows="4"
                    className="border rounded-md py-2 px-4 w-full resize-vertical"
                    placeholder="Please provide any additional information that may be relevant..."
                    onChange={(e) => {
                        const newValue = e.target.value
                        setFormData({
                            ...formData,
                            form_responses: {
                                ...formData.form_responses,
                                question7: {
                                    question_title: "Additional Information",
                                    responses: [
                                        {
                                            answer_text: "Additional Information",
                                            responses: [],
                                            text_response: newValue
                                        }
                                    ]
                                }
                            }
                        })
                    }}
                    value={formData.form_responses?.question7?.responses?.[0]?.text_response || ''}
                ></textarea>
            </div>
        </div>
    );
};

export default AdditionalInfoQuestion;